module.exports = __webpack_public_path__ + "img/store.aa01e6cc.svg";